import type { TargetingLabels } from './useTargetingLabels.tsx';

type MapKeysToLabelsFunction = (labels: TargetingLabels, keys?: (string | null)[] | null) => string[];

export const useMapKeysToLabels: MapKeysToLabelsFunction = (labels, keys = []) => {
  const filteredKeys = keys && Array.isArray(keys) ? keys.filter((k): k is string => Boolean(k)) : [];

  const values = filteredKeys.flatMap(key => {
    const path = key.split('.').slice(1);
    let value: unknown = labels;

    for (const prop of path) {
      // A label names its whole subtree: the forecaster reports the inner keys of a dict field it does not use
      // (e.g. `targeting.contextual_segment.includes`), which a client shows as that field.
      if (typeof value === 'string') break;

      if (value && typeof value === 'object' && prop in value) {
        value = value[prop];
      } else {
        return [];
      }
    }

    return typeof value === 'string' ? value : [];
  });

  return [...new Set(values)].sort();
};
